// src/components/LanguageSwitcher.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { Globe } from 'react-bootstrap-icons';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [show, setShow] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        // Сохраняем предпочтение языка в localStorage
        localStorage.setItem('i18nextLng', lng);
        setShow(false);
    };

    // Отображаемый код языка
    const getLanguageCode = () => {
        switch (i18n.language) {
            case 'ru': return 'RU';
            case 'es': return 'ES';
            case 'de': return 'DE';
            case 'pt': return 'PT';
            case 'ar': return 'AR';
            case 'kk': return 'KK';
            default: return 'EN';
        }
    };

    return (
        <div className="language-switcher" style={{ position: 'relative', zIndex: 1050 }}>
            <Dropdown show={show} onToggle={(isOpen) => setShow(isOpen)}>
                <Dropdown.Toggle
                    variant="outline-light"
                    id="language-dropdown"
                    size="sm"
                    className="d-flex align-items-center"
                    style={{ zIndex: 1050 }}
                >
                    <Globe className="me-1" />
                    {getLanguageCode()}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ zIndex: 1051 }}>
                    <Dropdown.Item
                        onClick={() => changeLanguage('en')}
                        active={i18n.language === 'en'}
                        style={{ cursor: 'pointer' }}
                    >
                        English
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => changeLanguage('ru')}
                        active={i18n.language === 'ru'}
                        style={{ cursor: 'pointer' }}
                    >
                        Русский
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => changeLanguage('es')}
                        active={i18n.language === 'es'}
                        style={{ cursor: 'pointer' }}
                    >
                        Español
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => changeLanguage('de')}
                        active={i18n.language === 'de'}
                        style={{ cursor: 'pointer' }}
                    >
                        Deutsch
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => changeLanguage('pt')}
                        active={i18n.language === 'pt'}
                        style={{ cursor: 'pointer' }}
                    >
                        Português
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => changeLanguage('ar')}
                        active={i18n.language === 'ar'}
                        style={{ cursor: 'pointer' }}
                    >
                        العربية
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => changeLanguage('kk')}
                        active={i18n.language === 'kk'}
                        style={{ cursor: 'pointer' }}
                    >
                        Қазақша
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default LanguageSwitcher;